import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const ChipService = {
  createChip,
  getAllChips,
  getAllChipsByParams,
  getChipById,
  getChipsByCategory,
  getChipTypes,
  updateChip,
  updateAvailableStatus,
  updateNumberByBulk,
  updatePricesByBulk,
  createBulkChip,
};

function createChip(body) {
  console.log(body);
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/chip`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllChips() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/chip`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllChipsByParams(params) {
  console.log("params SERVICE", params);
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/chip/by-params`, {
      params,
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getChipById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/chip/by-id?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getChipsByCategory(body) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/chip/by-chipCatalogue`, {
      params: body,
    })
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function getChipTypes() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/chip/catalogue-chip`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateChip(id, body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/chip/id?id=${id}`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateAvailableStatus(chipArray) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/chip/available-status`, chipArray)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateNumberByBulk(chipArray) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/chip/number`, chipArray)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function updatePricesByBulk(chipArray, chipParams) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/chip/prices`, { chipParams, chipArray })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function createBulkChip(chipArray) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/chip/bulk`, chipArray)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
